<template>
	<v-flex>
		<v-textarea
				:readonly="readonly"
				:label="$props.label"
				:placeholder="' '"
				:error-messages="$props.error"
				:type="$props.type"
				:counter="$props.counter"
				:maxLength="lengthComputed"
				v-model="inputValue"></v-textarea>
	</v-flex>
</template>

<script>
	export default {
		name: "TextArea",
		props: ['value', 'readonly', 'error', 'placeholder', 'label', 'type', 'counter', 'maxLength'],
		data() {
			return {
				inputValue: this.$props.value
			}
		},
		computed: {
			lengthComputed() {
				let length = undefined;
				if (typeof this.$props.maxlength !== 'undefined') {
					length = this.$props.maxlength;
				}
				if (typeof this.$props.counter !== 'undefined') {
					length = this.$props.counter;
				}
				return length
			}
		},
		watch: {
			inputValue() {
				this.$emit('input', this.inputValue);
			},
			value() {
				this.inputValue = this.$props.value;
			}
		}
	}
</script>

<style scoped>
	>>> textarea {
		height: 1000px;
	}
</style>
